<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加店员-->
      <div class="common-form">添加商户</div>
      <el-form-item label="商户名称" prop="supplier.name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入商户名称"></el-input>
      </el-form-item>
      <el-form-item label="过期时间">
        <el-date-picker v-model="form.supplier.expire_time_text" type="date" placeholder="过期时间" value-format="yyyy-MM-dd" :disabled="form.supplier.no_expire"></el-date-picker>
        <el-checkbox v-model="form.supplier.no_expire" class="pl16">永不过期</el-checkbox>
      </el-form-item>
      <el-form-item label="账号" prop="supplier.user_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.user_name" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="supplier.password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.password" placeholder="请输入登录密码" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="supplier.confirm_password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.confirm_password" placeholder="请输入确认密码" type="password"
          class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="supplier.link_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.link_name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="风控征信通道预充金额" prop="supplier.tongdao" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.tongdao" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="企业完整名称" prop="supplier.company_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.company_name" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="营业执照号" prop="supplier.yyzzh" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.yyzzh" placeholder="请输入金额"></el-input>
      </el-form-item>

      <el-form-item label="法人姓名" prop="supplier.fr_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.fr_name" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="supplier.idcard" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.idcard" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="supplier.link_phone" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.link_phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="支付宝商户号" prop="supplier.alipay_account" :rules="[
        { required: true, message: '请输入支付宝商户号' },
        { type: 'number', message: '支付宝账号必须为数字值' }
      ]">
        <el-input v-model.number="form.supplier.alipay_account" placeholder="请输入支付宝支付宝商户号" style="width: 460px;" />
      </el-form-item>
      <el-form-item label="支付宝绑定状态">
        <el-switch v-model="form.supplier.alipay_bind" disabled />
      </el-form-item>
      <el-form-item label="分销百分比" prop="supplier.fengxiao" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.fengxiao" placeholder="请输入分销百分比"></el-input>
      </el-form-item>
      <el-form-item label="日接单数量" prop="supplier.accept_orders_num" :rules="[{ required: true, message: '请输入日接单数量' }]">
        <el-input class="max-w460" v-model="form.supplier.accept_orders_num" placeholder="请输入日接单数量"></el-input>
      </el-form-item>
      <el-form-item label="门店logo"
       :rules="[{ required: true, message: ' ' }]"
      >
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
          <div v-if="form.supplier.logo_id != ''" class="img">
            <img :src="logo_file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="主营类别" prop="supplier.category_id" :rules="[{ required: true, message: ' ' }]">
        <el-select v-model="form.supplier.category_id" placeholder="请选择">
          <el-option v-for="(item, index) in category" :key="index" :label="item.name"
            :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否开启接单">
        <el-radio-group v-model="form.supplier.accept_orders">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="支付宝账号" prop="supplier.alipay_account" :rules="[
        { required: true, message: '请输入支付宝账号' },
        { type: 'number', message: '支付宝账号必须为数字值' }
      ]">
        <el-input v-model.number="form.supplier.alipay_account" placeholder="请输入支付宝账号" style="width: 460px;" />
      </el-form-item> -->
      <el-form-item label="店铺类型">
        <el-radio-group v-model="form.supplier.store_type">
          <el-radio :label="10">普通</el-radio>
          <el-radio :label="20">自营</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="地址" prop="supplier.address" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.address" placeholder="请输入地址"></el-input>
      </el-form-item>

      <el-form-item label="身份证正面">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('card_zm')">选择图片</el-button>
          <div v-if="form.supplier.card_zm != ''" class="img">
            <img :src="form.supplier.card_zm" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="身份证反面">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('card_fm')">选择图片</el-button>
          <div v-if="form.supplier.card_fm != ''" class="img">
            <img :src="form.supplier.card_fm" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="营业执照">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('business')">选择图片</el-button>
          <div v-if="form.supplier.business_id != ''" class="img">
            <img :src="business_file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="签章确认与授权书照片">
        <el-row>
          <el-button
            icon="el-icon-picture-outline"
            @click="openUpload('lj_sqs')"
            >选择图片</el-button
          >
          <div v-if="form.supplier.lj_sqs != ''" class="img">
            <img :src="form.supplier.lj_sqs" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="授权委托书照片">
        <el-row>
          <el-button
            icon="el-icon-picture-outline"
            @click="openUpload('lj_wts')"
            >选择图片</el-button
          >
          <div v-if="form.supplier.lj_wts != ''" class="img">
            <img :src="form.supplier.lj_wts" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="绑定用户">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="userClick()">选择用户</el-button>
          <div v-if="form.supplier.user_id != 0" class="img">
            <!-- <img :src="user_info.avatarUrl" width="100" height="100" /> -->
            <el-tag>{{ user_info.username }}</el-tag>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="商家介绍" prop="supplier.description">
        <el-input type="textarea" v-model="form.supplier.description" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--管理用户-->
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
    /*上传组件*/
    Upload,
    /*选择用户*/
    GetUser
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        supplier: {
          logo_id: 0,
          business_id: 0,
          open_service: 0,
          category_id: '',
          user_id: 0,
          store_type: 10,
          accept_orders_num: '',
          accept_orders: 1,
          no_expire:true,
          lj_sqs:'', //签章确认与授权书照片
          lj_wts:'', //授权委托书照片

          alipay_account: 0,  // 支付宝账号
          alipay_bind: null, // 支付宝绑定状态
        },
      },
      logo_file_path: '',
      business_file_path: '',
      /*是否打开添加弹窗*/
      open_add: false,
      storeList: [],
      category: [],
      /*是否上传图片*/
      isupload: false,
      loading: false,
      type: 'logo',
      open_user: false,
      user_info: {}
    };
  },
  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*获取广告类别*/
    getCategoryList() {
      let self = this;
      let Params = {};

      SupplierApi.toaddSupplier(Params, true)
        .then(res => {
          self.category = res.data.category;
          if (self.category.length > 0) {
            self.form.category_id = self.category[0].category_id;
          }
        })
        .catch(error => {

        });
    },
    onSubmit() {
      let self = this;
      if (self.form.supplier.no_expire == true) {
        self.form.supplier.expire_time = 0;
      }else{
        self.form.supplier.expire_time = self.form.supplier.expire_time_text;
      }
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          if(self.logo_file_path == ''){
            self.$message({
              message: '请上传门店logo',
              type: 'error'
            });
            self.loading = false;
            return;
          }
          SupplierApi.addSupplier(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，商户添加成功',
                  type: 'success'
                });
                self.$router.push('/supplier/supplier/index');
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.type == 'logo') {
          this.logo_file_path = e[0].file_path;
          this.form.supplier.logo_id = e[0].file_id;
        } else if (this.type == 'business') {
          this.business_file_path = e[0].file_path;
          this.form.supplier.business_id = e[0].file_id;
        } else if (this.type == 'card_zm') {
          this.form.supplier.card_zm = e[0].file_path;
        } else if (this.type == 'card_fm') {
          this.form.supplier.card_fm = e[0].file_path;
        } else if (this.type == "lj_sqs") {
          this.form.supplier.lj_sqs = e[0].file_path;
        } else if (this.type == "lj_wts") {
          this.form.supplier.lj_wts = e[0].file_path;
        }
      }
      this.isupload = false;
    },


    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开弹出层*/
    userClick() {
      this.open_user = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      console.log(e);
      if (e.type != 'error') {
        this.user_info = e.params[0];
        this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },

  }

};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/add.vue